// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 890) return "static/chunks/51ef5e1c-08aa1bd53a599a81.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "19ce574c9b9b7229" + ".js";
};